import { useTranslation } from 'react-i18next';

interface TaskCardKanbanHideSectionProps {
    id: string;
    checked: boolean;
    disabled: boolean;
    onChange: (checked: boolean) => void;
}

const TaskCardKanbanHideSection = ({ id, checked, disabled, onChange }: TaskCardKanbanHideSectionProps) => {
    const { t } = useTranslation('Tasks');

    return (
        <section className="task-card-section mb-0 pt-2">
            <div className="task-card-panel">
                <div className="form-check form-switch mb-0">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id={id}
                        checked={checked}
                        disabled={disabled}
                        onChange={(e) => onChange(e.currentTarget.checked)}
                    />
                    <label className="form-check-label" htmlFor={id}>
                        <span className="d-block fs-12">{t('labelKanbanHide')}</span>
                        <span className="d-block text-muted" style={{ fontSize: '0.65rem', lineHeight: 1.35 }}>
                            {t('hintKanbanHide')}
                        </span>
                    </label>
                </div>
            </div>
        </section>
    );
};

export default TaskCardKanbanHideSection;
